<script setup>
    import _ from 'lodash'
    import {
        PerfectScrollbar
    } from 'vue3-perfect-scrollbar'
    import avatar1 from '@images/avatars/avatar-1.png'

    import switchDistributor from '@/components/auth/switch-distributor.vue'

    // --------------- 👉 User Pinia Store
    import {
        useStore
    } from '@/stores/user'
    const userStore = useStore()
    // --------------- 👉 User Pinia Store
    const featureKeys = userStore.featureKeys
    const userInfo = userStore.info //useState('auth.user.info')

    const userIcon = computed(() => {
        const icon = _.get(userInfo, 'profile.photo.thumbnail')
        return icon ? icon : avatar1
    })
    const userProfileList = [{
            type: 'divider'
        },
        {
            type: 'navItem',
            icon: 'ri-user-line',
            value: 'my-account',
            to: '/user?my-account',
            dataTestid: 'user-profile-account'
        },
        {
            type: 'navItem',
            icon: 'ri-coin-line',
            value: 'my-coin',
            to: '/user?my-coin',
            dataTestid: 'user-profile-health-coin',
            feature: 'enable_credits'
        },
        // {
        //     type: 'navItem',
        //     icon: 'ri-question-line',
        //     value: 'my-address',
        //     to: '/user?my-address',
        //     dataTestid: 'user-profile-address'
        // },
        // {
        //     type: 'divider'
        // },
        // {
        //     type: 'navItem',
        //     icon: 'ri-settings-4-line',
        //     value: 'order-history',
        //     to: '/user?order-history',
        //     dataTestid: 'user-profile-order-history'
        // },
        // {
        //     type: 'navItem',
        //     icon: 'ri-money-dollar-circle-line',
        //     value: 'payment-method',
        //     to: '/user?payment-method',
        //     dataTestid: 'user-profile-payment-method'
        // },
        // {
        //     type: 'navItem',
        //     icon: 'ri-money-dollar-circle-line',
        //     value: 'bank-account',
        //     to: '/user?bank-account',
        //     dataTestid: 'user-profile-bank-account'
        // },
        // {
        //     type: 'navItem',
        //     icon: 'ri-money-dollar-circle-line',
        //     value: 'coupon-code',
        //     to: '/user?coupon-code',
        //     dataTestid: 'user-profile-coupon-code'
        // },
        // {
        //     type: 'divider'
        // },
    ]
    import healthCoinSvg from '@images/svg/HealthCoin.svg'

    const possible_distributors = computed(() => {
        const distributors = localStorage.getItem('possible_distributors')
        const _distributors = distributors ? JSON.parse(distributors) : []
        return _.filter(_distributors, a => !a.mfa.enabled)
    })

    const isPossibleDistributorDialog = ref(false)


    async function userLogin(selected_user) {
        const slug = _.get(selected_user, 'distributor.slug', '')
        const user_uuid = _.get(selected_user, 'uuid', '')
        const token = _.get(selected_user, 'token.value', '')
        useState(`slug`, () => slug)
        localStorage.setItem('slug', slug)
        const accessObject = {
            uuid: user_uuid,
            token
        }
        try {
            const res = await postRequest(`auth/v2/access-token`, accessObject, true, true)
            if (_.get(res, 'access_token')) {
                navigateTo(`/auto-login?token=${_.get(res, 'access_token')}&v3=true`, {
                    replace: false
                })
                isPossibleDistributorDialog.value = false
            } else {
                if (_.get(res, 'status') === 403) {
                    errors.value.email = t(`auth.login.errors.${res.status}`)
                    return false
                }
            }
        } catch (err) {
            console.log(err)
        }
    }
</script>

<template>
    <VBadge dot bordered location="bottom right" offset-x="3" offset-y="3" color="success">
        <VAvatar class="cursor-pointer" size="38" data-testid="user-profile">
            <VImg :src="userIcon" />
            <!-- SECTION Menu -->
            <VMenu activator="parent" width="230" location="bottom end" offset="15px" data-testid="user-profile-menu">
                <VList>
                    <!-- 👉 User Avatar & Name -->
                    <VListItem>
                        <template #prepend>
                            <VListItemAction start>
                                <VBadge dot location="bottom right" offset-x="3" offset-y="3" color="success">
                                    <VAvatar color="primary" variant="tonal">
                                        <VImg :src="userIcon" />
                                    </VAvatar>
                                </VBadge>
                            </VListItemAction>
                        </template>

                        <h6 class="text-sm font-weight-medium">
                            {{  $get(userInfo, 'profile.first_name') }}
                            {{  $get(userInfo, 'profile.last_name') }}
                        </h6>
                        <VListItemSubtitle class="text-capitalize text-disabled">
                            <span v-for="role in $get(userInfo, 'roles')" :key="role.id">
                                {{  $lang(role, 'name_translation') }}
                            </span>
                        </VListItemSubtitle>
                        <VListItemSubtitle class="text-capitalize text-disabled"
                            v-if="$includes(featureKeys, 'enable_credits')">
                            <div class="d-flex justify-start align-center">
                                <Component :is="healthCoinSvg" />
                                <div class="mt-1 ml-1">
                                    {{ $coinTag($get(userStore, 'info.reward_points')) }}
                                </div>
                            </div>
                        </VListItemSubtitle>
                    </VListItem>

                    <PerfectScrollbar :options="{ wheelPropagation: false }">
                        <template v-for="item in userProfileList" :key="item.title">
                            <VListItem v-if="item.type === 'navItem'" :value="item.value"
                                v-show="$get(item, 'feature') ? $includes(featureKeys, $get(item, 'feature')) : true"
                                @click="item.to ? navigateTo(item.to) : null" :data-testid="item.dataTestid">
                                <template #prepend>
                                    <VIcon :icon="item.icon" size="22" />
                                </template>

                                <VListItemTitle>{{ $t(`mainmenu.user.${item.value}`) }}</VListItemTitle>

                                <template v-if="item.badgeProps" #append>
                                    <VBadge inline v-bind="item.badgeProps" />
                                </template>
                            </VListItem>

                            <VDivider v-else class="my-1" />
                        </template>
                        <VDialog v-model="isPossibleDistributorDialog" persistent max-width="600"
                            v-if="$size(possible_distributors) > 1">
                            <template #activator="{ props }">
                                <VListItem link v-bind="props">
                                    <template #prepend>
                                        <VIcon icon="ri-user-line" size="22" />
                                    </template>
                                    <VListItemTitle link>
                                        {{ $t('mainmenu.user.change-distributor') }}
                                    </VListItemTitle>
                                </VListItem>
                            </template>
                            <VCard class="px-2">
                                <VCardItem class="dialog-header pb-3">
                                    <DialogCloseBtn variant="text" size="default"
                                        @click="isPossibleDistributorDialog = false" />
                                    <template v-slot:title>
                                        <span
                                            class="text-h5 font-weight-bold">{{ $t('mainmenu.user.change-distributor') }}</span>
                                    </template>
                                </VCardItem>
                                <switchDistributor :data="{ possible_distributors }" :onSubmit="userLogin" />
                            </VCard>
                        </VDialog>

                        <VListItem>
                            <VBtn block color="error" append-icon="ri-logout-box-r-line" to="/logout"
                                data-testid="auth-logout">
                                {{  $t(`mainmenu.user.logout`)  }}
                            </VBtn>
                        </VListItem>
                    </PerfectScrollbar>
                </VList>
            </VMenu>
            <!-- !SECTION -->
        </VAvatar>
    </VBadge>
</template>